/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import useAPIHandler from '../../../hook/use-api-handler';
import useSnackbar from '../../../hook/use-snakbar';
import { getDateProperFormatForInput, getErrorDetailsFn, getInputFieldProps } from '../../../utils/common';
import { logger, safeString } from '../../../utils/logger';
import useOrgDetailsService from '../../organization-details/use-orgdetails-service';
import { EPF_API, EPF_INITIAL_STATE, EPF_INPUT_FIELDS } from './epf-constant';
import { epfFormSchema } from './epf-validation';


const useEpfService = () => {
  // Modal

   // Modal
   const [openStatutoryEPFModal, setOpenStatutoryEPFModal] =
  useState(false);

 const [openEPFAddressModal, setOpenEPFAddressModal] =useState(false);

 const handleOpenStatutoryEPFModal = () => setOpenStatutoryEPFModal(true);
 const handleCloseStatutoryEPFModal = () => setOpenStatutoryEPFModal(false);

 const handleOpenEPFAddressModal = () => setOpenEPFAddressModal(true);
 const handleCloseEPFAddressModal = () => setOpenEPFAddressModal(false);
  // Modal
  const [viewEpfDetails, setViewEpfDetails] = useState({})
  const [open, setOpen] = useState(false);




  const [epfInputs, setEPFInputs] = useState(structuredClone(EPF_INITIAL_STATE));

  const { fetchData } = useAPIHandler();
  const [createUpdateLoading, setCreateUpdateLoading] = useState(false);

  const [errors, setErrors] = useState({});

  function handleDisableAllEpfFn() {
    if (!epfInputs.epfOrganizationIsDisabled) {
      setErrors({});
      setEPFInputs({ ...structuredClone(EPF_INITIAL_STATE), epfOrganizationIsDisabled: true });
    } else {
      setEPFInputs((prev) => ({ ...prev, epfOrganizationIsDisabled: false }));

    }
  }

  const handleClickOpen = () =>{
    
    // setEPFInputs(prev=>({ ...prev, epfOrganizationEmployeeContribution: prev?.epfOrganizationEmployeeContribution?prev?.epfOrganizationEmployeeContribution: 'restrict_contribution',epfOrganizationStatus: prev?.epfOrganizationStatus? prev?.epfOrganizationStatus:  "12%",epfOrganizationEmployerContribution: prev?.epfOrganizationEmployerContribution? prev?.epfOrganizationEmployerContribution: 'restrict_contribution'}))
    
    setOpen(true);
    
  
  };
  const handleClose = () => setOpen(false);
  const {
    snackbarVisible,
    snackbarMessage,
    openSnackbar,
    closeSnackbar,
    snackColor,
  } = useSnackbar();

  const [view, setView] = useState(false);
  const handleViewOpen = () => {
    setView(true);
    setOpen(false);
  };
  const handleViewClose = () => setView(false);




  function handleBlurFn(e, name) {
    let value = e;

    if (e && e.target) {
      value = e.target.value;
    }

    const fieldSchema = epfFormSchema.extract(name);
    const { error } = fieldSchema.validate(value);

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error ? error.details[0].message : undefined,
    }));
  }



  const handleChangeFunction = (e, name) => {
    let value = e;

    if (e && e.target) {
      value = e.target.value;
    }

    if (
      EPF_INPUT_FIELDS[name]?.customOptions &&
      EPF_INPUT_FIELDS[name]?.customOptions?.formatValueFn
    ) {
      value = EPF_INPUT_FIELDS[name]?.customOptions?.formatValueFn(
        value,
        epfInputs
      );
    }

    setEPFInputs((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));

    const fieldSchema = epfFormSchema.extract(name);
    if (fieldSchema) {

      const { error } = fieldSchema.validate(value, {
        //   context: { allowanceType: allowance.allowanceType },
      });

    
      if (!error) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: undefined,
        }));
      }
    }
  };

  const handleSubmitFn = async () => {
    const URL = EPF_API.EPF_CREATE.URL;
    const METHOD = EPF_API.EPF_CREATE.METHOD;



    const {


      epfOrganizationIsDisabled,

      epfOrganizationMaster1,
      epfOrganizationMaster2,
      epfOrganizationMaster3,
      epfOrganizationMaster4,


      epfOrganizationNumber,
      epfOrganizationStatus,
      epfOrganizationCoverageDate,
      epfOrganizationEmployeeContribution,
      epfOrganizationEmployerContribution,
      epfOrganizationOffice,
      epfOrganizationAddress,
      epfOrganizationCity,
      epfOrganizationState,
      epfOrganizationCountry,
      epfOrganizationPinCode,
      epfOrganizationLocation,

    } = epfInputs;


    const payload = {
      data: {
        epfOrganizationNumber,
        epfOrganizationStatus,
        epfOrganizationCoverageDate,
        epfOrganizationEmployeeContribution,
        epfOrganizationEmployerContribution,
        epfOrganizationOffice : epfOrganizationOffice??"",
        epfOrganizationAddress  : epfOrganizationAddress??"",
        epfOrganizationCity  : epfOrganizationCity??"",
        epfOrganizationState: epfOrganizationState ?? "",
        epfOrganizationCountry: "1",
        epfOrganizationPinCode : epfOrganizationPinCode ?? "",
        epfOrganizationLocation : epfOrganizationLocation ?? "",
        epfOrganizationIsDisabled: false
        // epfOrganizationMaster1,
        // epfOrganizationMaster2,
        // epfOrganizationMaster3,
        // epfOrganizationMaster4,
      },
      url: URL,
      method: METHOD,
    };

    let error = {};


    if (!epfOrganizationIsDisabled) {

      const { error: allErrors } = epfFormSchema.validate(
        {
          orgId: "78",
          epfOrganizationNumber,
          epfOrganizationStatus,
          epfOrganizationCoverageDate,
          epfOrganizationEmployeeContribution,
          epfOrganizationEmployerContribution,
          epfOrganizationOffice,
          epfOrganizationAddress,
          epfOrganizationCity,
          epfOrganizationState,
          epfOrganizationCountry,
          epfOrganizationPinCode,
          epfOrganizationLocation,
        },
        {
          abortEarly: false,
        }
      );
      error = allErrors;
      const epfOrganizationMaster = [];

      if (epfOrganizationMaster1 === true) {
        epfOrganizationMaster.push(1)
      }
      if (epfOrganizationMaster2 === true) {
        epfOrganizationMaster.push(2)

      }
      if (epfOrganizationMaster3 === true) {
        epfOrganizationMaster.push(3)

      }
      if (epfOrganizationMaster4 === true) {

        epfOrganizationMaster.push(4)

      }

      payload.data.epfOrganizationMaster = epfOrganizationMaster;
      payload.data.epfOrganizationIsDisabled = true;

    } else {
      payload.data = { epfOrganizationIsDisabled: false };
    }


    if (error && error?.details?.length > 0) {
      const validationErrors = error.details.reduce((acc, err) => {
        const pathname = err.path.join(".");
        acc[pathname] = err.message;
        return acc;
      }, {});
      setErrors(validationErrors);
    } else {
      setCreateUpdateLoading(true);

      try {
        await fetchData(payload);
    getEpfFn();

        setViewEpfDetails(payload?.data);
        // if (handleCloseStatutoryEPFModal) {
        //   handleCloseStatutoryEPFModal()
        // }
        setOpenStatutoryEPFModal(false)
        setOpenEPFAddressModal(false)
        openSnackbar({
          message: "EPF Updated Succesfully!",
          color: "success",
        });
      } catch (error) {

        const {


          message,
          errorObj
        } = getErrorDetailsFn(error);

        openSnackbar({
          message,
          color: "danger",
        });
        setErrors(errorObj);
        setCreateUpdateLoading(false);
      } finally {
        setCreateUpdateLoading(false);
      }
    }
  };

  function handleCheckboxEpfFn() {

  }


  const [employeeAssumeSalary, setEmployeeAssumeSalary] = useState(20000);
  let epsAmount = 0;
  let employeerContributionAmount = 15000;
  let employeeContributionAmount = 15000;
  const epfOrganizationStatus10Or12 = parseInt(
    epfInputs?.epfOrganizationStatus ? epfInputs?.epfOrganizationStatus : 12
  );

  if (
    epfInputs?.epfOrganizationEmployerContribution === "restrict_contribution"
  ) {
    epsAmount = (15000 * 8.33) / 100;
  } else {
    epsAmount =
      (employeeAssumeSalary * 8.33) / 100 > 1250
        ? 1250
        : (employeeAssumeSalary * 8.33) / 100;
  }

  if (
    epfInputs?.epfOrganizationEmployerContribution !== "restrict_contribution"
  ) {
    employeerContributionAmount = employeeAssumeSalary;
  }
  if (
    epfInputs?.epfOrganizationEmployeeContribution !== "restrict_contribution"
  ) {
    employeeContributionAmount = employeeAssumeSalary;
  }
  const [stateList, setStateList] = useState([]);
  const getInputFieldPropsFn = (fieldName = "") => {
    // eslint-disable-next-line no-unused-vars
    const { customOptions = {}, ...restProps } =
      EPF_INPUT_FIELDS[fieldName] || {};

    let disabled = !!restProps.disabled;
    if (epfInputs.epfOrganizationIsDisabled === true) {
      disabled = true;
    }

    const error = safeString(errors[fieldName]);
    const props = {
      ...restProps,
      ...getInputFieldProps({
        name: fieldName,
        stateValues: epfInputs,
        type: restProps.type || "text",
        error,
        handleChangeFunction,
        handleBlurFn
      }),
      disabled,
    };


    return props;
  };

  const [getProfileLoading, setgetProfileLoading] = useState(false);



  function getEpfFn(){
    setgetProfileLoading(true);
    const URL = EPF_API.EPF_LIST.URL;
    const METHOD = EPF_API.EPF_LIST.METHOD;
    const payload = {
      url: URL,
      METHOD
    }


    try {

      fetchData(payload).then(
        (res) => {

          const resData = res?.data || {};



          resData.epfOrganizationCoverageDate = getDateProperFormatForInput(resData?.epfOrganizationCoverageDate);

          const epfOrganizationMaster = resData.epfOrganizationMaster || []

          if (epfOrganizationMaster.includes(1)) {
            resData.epfOrganizationMaster1 = true;
          }
          if (epfOrganizationMaster.includes(2)) {
            resData.epfOrganizationMaster2 = true;
          }
          if (epfOrganizationMaster.includes(3)) {
            resData.epfOrganizationMaster3 = true;
          }
          if (epfOrganizationMaster.includes(4)) {
            resData.epfOrganizationMaster4 = true;
          }


          setEPFInputs({ ...resData, country: "India", epfOrganizationCountry: 1, epfOrganizationIsDisabled: !resData?.epfOrganizationIsDisabled });
          setgetProfileLoading(false);
          setViewEpfDetails({ ...resData, country: "India", epfOrganizationCountry: 1, epfOrganizationIsDisabled: !resData?.epfOrganizationIsDisabled })
        }

      ).catch(err => {
        setgetProfileLoading(false);

      });


    } catch (error) {
      setgetProfileLoading(false);
    }
  }

  useEffect(() => {

    getEpfFn();

    fetchData({ url: "/common/state" }).then(
      (res) => {

        setStateList(res?.data?.map(
          it => ({
            ...it,

            id: it.state_id,
            name: it.state_name
          })
        ));
      }
    );
  }, []);
  const { allState } = useOrgDetailsService()
  function getStateName(id) {
    const stateName = allState.find(item => item.id === id);

    return stateName ? stateName?.name : 'N/A'
  }
  return {
    handleDisableAllEpfFn,
    handleViewClose, handleViewOpen, view, handleClickOpen, handleClose, open, setOpen, handleSubmitFn, createUpdateLoading, getInputFieldPropsFn, stateList,
    handleCheckboxEpfFn,
    snackbarVisible,
    snackbarMessage,
    openSnackbar,
    closeSnackbar,
    snackColor,
    getProfileLoading, setgetProfileLoading,

    epfInputs,
    viewEpfDetails,
    openStatutoryEPFModal,
    handleOpenStatutoryEPFModal,
    handleCloseStatutoryEPFModal,
    openEPFAddressModal,
    handleOpenEPFAddressModal,
    handleCloseEPFAddressModal,
    getStateName
  }
}

export default useEpfService